import Vue from 'vue'
import Router from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import links from '../nav.route'
import {
    localToken
} from "@/libs/func";

//console.log(links)
import MintUI from 'mint-ui'
Vue.use(MintUI)
import login from '@/view/login/login'
import shopSales from '@/view/shopSales/shopSales'
import tradTrends from '@/view/shopSales/tradTrends'
import error from '@/view/ErrorPage/Error'
Vue.use(Router)
Vue.use(BootstrapVue);
//export default new Router({
const routers = new Router({
    mode: 'history',
    routes: [
        // {
        //     path: '/', //会员首页 (默认进入)
        //     name: 'login',
        //     component: login,
        //     meta: {
        //         title: ''
        //     }
        // },
        {
            path: '/', //会员首页 (默认进入)
            name: 'shopSales',
            component: shopSales,
            meta: {
                title: ''
            }
        },
        {
            path: '/tradTrends',
            name: 'tradTrends',
            component: tradTrends,
            meta: {
                title: '交易趋势'
            }
        },
        {
            path: '/Error',
            name: 'Error',
            component: error,
            meta: {
                title: ''
            }
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
});

export default routers;


// WEBPACK FOOTER //
// ./src/router/routers.js